import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetUserAffiliateDetailsPayload, UserAffiliateState } from "./types";
import * as thunks from "./thunks";
import dayjs from "dayjs";

const initialState: UserAffiliateState = {
  userAffiliateVouchers: [],
  isUserAffiliateVouchersLoading: false,
  getUserAffiliateDetailsPayload: {
    voucher_code: "",
    sold_date_from: dayjs().startOf("month").format("YYYY-MM-DD").toString(),
    sold_date_to: dayjs(Date.now()).format("YYYY-MM-DD").toString(),
  },
  isUserAffiliateDetailsLoading: false,
  getUserAffiliateDetailsResponse: {},
};

const slice = createSlice({
  name: "UserAffiliate",
  initialState,
  reducers: {
    updateGetDetailsPayload: (
      state,
      { payload }: PayloadAction<GetUserAffiliateDetailsPayload>
    ) => {
      state.getUserAffiliateDetailsPayload = {
        ...state.getUserAffiliateDetailsPayload,
        ...payload,
      };
    },
  },
  extraReducers(builder) {
    builder.addCase(
      thunks.getUserAffiliateVouchersThunk.pending,
      (state, { payload }) => {
        state.isUserAffiliateVouchersLoading = true;
      }
    );
    builder.addCase(
      thunks.getUserAffiliateVouchersThunk.rejected,
      (state, { payload }) => {
        state.isUserAffiliateVouchersLoading = false;
      }
    );
    builder.addCase(
      thunks.getUserAffiliateVouchersThunk.fulfilled,
      (state, { payload }) => {
        state.isUserAffiliateVouchersLoading = false;
        state.userAffiliateVouchers = payload?.originalData?.data || [];
      }
    );
    // Details
    builder.addCase(
      thunks.getUserAffiliateDetailsThunk.pending,
      (state, { payload }) => {
        state.isUserAffiliateDetailsLoading = true;
      }
    );
    builder.addCase(
      thunks.getUserAffiliateDetailsThunk.rejected,
      (state, { payload }) => {
        state.isUserAffiliateDetailsLoading = false;
      }
    );
    builder.addCase(
      thunks.getUserAffiliateDetailsThunk.fulfilled,
      (state, { payload }) => {
        state.isUserAffiliateDetailsLoading = false;
        state.getUserAffiliateDetailsResponse = payload?.originalData;
      }
    );
  },
});

export const reducer = slice.reducer;
export const actions = { ...slice.actions, ...thunks };
